import React, { useState, useEffect, Fragment } from "react";
import { withRouter, Link } from "react-router-dom";
import { toolsAPI, usuariosAPI } from "../../utils/funcionesAPI";
import { manejadorDeRespuesta } from "../../utils/Tools";
import DatosPersonales from "./DatosPersonales";
import cuenta from "../../imagenes/datos/cuenta.jpg";
import cuenta2x from "../../imagenes/datos/cuenta@2x.jpg";
import { toast, ToastContainer } from "react-toastify";
import LoaderFormal from "../Global/LoaderFormal";
import DatosFacturacionMiPerfil from "./DatosFacturacionMiPerfil";
//import { askForPermissioToReceiveNotifications} from '../../push-notification';
//import firebase from 'firebase';

const MiPerfil = (props) => {
  const { history } = props;
  const [usuario, setUsuario] = useState({
    nombre: "",
    tipoCliente: "IND",
    cliente: {
      tipoDocumento: { idTipoDocumento: 1, sigla: "DNI" },
      numeroDocumento: "0",
      sexo: "M",
      nacionalidad: "ARG",
      telefono: "",
      celular: "",
      fechaNacimiento: "",
      pais: { codigo: "SIN" },
      provincia: { codigo: "SIN" },
      direccion: "",
      numeroCalle: "",
      codigoPostal: "",
      partido: { id: "0", codigo: "SIN" },
      localidad: { id: "0" },
      categoriaIVA: { id: 1 },
      legajo: "",
      mail: "",
    },
  });

  const [loaded, setLoaded] = useState(false);
  const [mostrarDatosPersonales, setMostrarDatosPersonales] = useState(true);

  const token = sessionStorage.getItem("token");
  const user = sessionStorage.getItem("usuario");
  const tipoCliente = sessionStorage.getItem("tipoCliente");

  if (!token && !user) {
    history.push("/login");
  }

  const traerMisDatos = () => {
    const data = JSON.stringify({ accion: "traerUsuario", token: token });

    usuariosAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta)) setUsuario(respuesta.data);
    });
  };

  useEffect(() => {
    traerMisDatos();
  }, [token]);

  const handleDatosUsuarioChange = (propiedad, valor) => {
    setUsuario({
      ...usuario,
      [propiedad]: valor,
    });
  };

  const handleDatosPersonalesChange = (propiedad, valor) => {
    setUsuario({
      ...usuario,
      cliente: {
        ...usuario.cliente,
        [propiedad]: valor,
      },
    });
  };

  const handleActualizarDatosPersonalesClick = () => {
    let data = JSON.stringify({
      accion: "actualizar",
      token,
      usuario,
    });
    setLoaded(false);
    usuariosAPI(data).then((respuesta) => {
      setLoaded(true);
      if (manejadorDeRespuesta(props, respuesta))
        toast.success(respuesta.data, {
          position: toast.POSITION.BOTTOM_CENTER,
          onClose: () => history.push("/"),
        });
    });
  };

  const handleActualizarDatosDeFacturacionClick = (formulario) => {
    let data = JSON.stringify({
      accion: formulario.id > 0 ? "actualizarDatosDeFacturacionDeClienteNuevo" : "insertarDatosDeFacturacion",
      token,
      formulario,
    });
    setLoaded(true);
    toolsAPI(data).then((respuesta) => {
      setLoaded(false);
      if (manejadorDeRespuesta(props, respuesta))
        toast.success(respuesta.data, {
          position: toast.POSITION.BOTTOM_CENTER,
          onClose: () => history.push("/"),
        });
    });
  };

  const handleEliminarDatosFacturacionClick = (idDatosDeFacturacion) => {
  
    let data = JSON.stringify({
      accion: "eliminarDatosDeFacturacionDeClienteNuevo",
      token,
      idDatosDeFacturacion
    });
    setLoaded(true);
    toolsAPI(data).then((respuesta) => {
      setLoaded(false);
      if (manejadorDeRespuesta(props, respuesta))
        toast.success(respuesta.data, {
          position: toast.POSITION.BOTTOM_CENTER,
          onClose: () => history.push("/"),
        });
    });
}

  return (
    <section className="datos">
      <LoaderFormal loaded={loaded} />
      <div className="container">
        <div className="row">
          <h1 className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            Mis datos
          </h1>
          <h6 className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <input
              className="checkRegistracion"
              type="radio"
              value="1"
              name="radio"
              checked={mostrarDatosPersonales}
              onChange={() => setMostrarDatosPersonales(true)}
            />
            Ingrese o edite sus datos personales
            <br />
            {tipoCliente === "IND" && (
              <Fragment>
                <input
                  className="checkRegistracion"
                  type="radio"
                  value="1"
                  name="radio"
                  checked={!mostrarDatosPersonales}
                  onChange={() => setMostrarDatosPersonales(false)}
                />
                Edite sus datos de facturacion
              </Fragment>
            )}
          </h6>

          <div className="row form-datos col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 img">
              <img
                src={cuenta}
                alt="Imagen de una mano femenina con un celular"
                srcSet={
                  cuenta + " 1x, " + cuenta2x + " 2x, " + cuenta2x + " 3x"
                }
              />
              <div className="listado">
                <Link to="/">Volver</Link>
              </div>
            </div>
            {mostrarDatosPersonales && (
              <DatosPersonales
                usuario={usuario}
                onInputsChange={handleDatosPersonalesChange}
                onInputsUsuarioChange={handleDatosUsuarioChange}
                onActualizarDatosPersonalesClick={
                  handleActualizarDatosPersonalesClick
                }
              />
            )}
            {!mostrarDatosPersonales && (
              <DatosFacturacionMiPerfil
                onActualizarDatosFacturacionClick={
                  handleActualizarDatosDeFacturacionClick
                }
                onEliminarDatosFacturacionClick={
                  handleEliminarDatosFacturacionClick
                }
              />
            )}
          </div>
        </div>
      </div>
      <ToastContainer />
    </section>
  );
};

export default withRouter(MiPerfil);



// WEBPACK FOOTER //
// ./src/components/MiPerfil/index.js